import { END_POINTS } from "../constants/url";
import { CustomerSupport, Issue, Offers, RatingRes } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
};

export const mainApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getIssue: builder.query<
      CommonResponseType & {
        data: { data: Issue[]; totalCount: number; totalPages: number };
      },
      {
        page: number;
        limit: number;
        search: string;
        id: string;
        status: number;
        type: string;
      }
    >({
      query: ({ page, limit, search, id, status, type }) => ({
        url: `${END_POINTS.issue}?status=${status}${
          id ? `&propertyId=${id}` : ""
        }&page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }${type ? `&type=${type}` : ""}`,
        method: "GET",
      }),
    }),

    getIssueById: builder.query<
      CommonResponseType & { data: Issue },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.issue}/${id}`,
        method: "GET",
      }),
    }),
    getInvoice: builder.mutation<
      CommonResponseType & { data: string },
      { offerId: string; issueId: string }
    >({
      query: (body) => ({
        url: `${END_POINTS.invoice}`,
        method: "POST",
        body,
      }),
    }),

    getOffers: builder.query<
      CommonResponseType & {
        data: { data: Offers[]; count: number; totalPages: number };
      },
      {
        page: number;
        limit: number;
        search: string;
        issueId?: string;
        status: number;
        userId?: string;
      }
    >({
      query: ({ page, limit, search, issueId, status, userId }) => ({
        url: `${END_POINTS.offer}?${issueId ? `&issueId=${issueId}` : ""}${
          userId ? `&userId=${userId}` : ""
        }&status=${status}&page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),

    acceptRejectOffer: builder.mutation<
      CommonResponseType & { data: Offers },
      {
        adminCommission?: number;
        offerId: string | undefined;
        status: number;
        rejectReason?: string;
      }
    >({
      query: (body) => ({
        url: `${END_POINTS.offer}`,
        method: "PUT",
        body,
      }),
    }),

    acceptRejectPayment: builder.mutation<
      CommonResponseType & { data: Offers },
      {
        offerId: string | undefined;
        paymentStatus: number;
      }
    >({
      query: (body) => ({
        url: `${END_POINTS.offer}`,
        method: "PUT",
        body,
      }),
    }),

    getCustomerSupport: builder.query<
      CommonResponseType & {
        data: {
          data: CustomerSupport[];
          count: number;
          totalPages: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
        status: number;
        role: number | string;
      }
    >({
      query: ({ page, limit, search, status, role }) => ({
        url: `${
          END_POINTS.customerSupport
        }?status=${status}&page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }${role ? `&role=${role}` : ""}`,
        method: "GET",
      }),
    }),

    deleteTicket: builder.mutation<
      CommonResponseType & { data: CustomerSupport },
      {
        revert: string;
        ticketId: string;
      }
    >({
      query: (body) => ({
        url: END_POINTS.customerSupport,
        method: "POST",
        body,
      }),
    }),
    deleteQuery: builder.query<CommonResponseType, { ticketId: string }>({
      query: (body) => ({
        url: `${END_POINTS.customerSupport}`,
        method: "DELETE",
        body,
      }),
    }),

    getRatings: builder.query<
      CommonResponseType & {
        data: { data: RatingRes[]; count: number; totalPages: number };
      },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.rating}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),

    getPaymentList: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          count: number;
          totalCommission: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.payment}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useLazyGetIssueQuery,
  useLazyGetIssueByIdQuery,
  useLazyGetOffersQuery,
  useAcceptRejectOfferMutation,
  useLazyGetCustomerSupportQuery,
  useDeleteTicketMutation,
  useGetInvoiceMutation,
  useLazyDeleteQueryQuery,
  useLazyGetRatingsQuery,
  useLazyGetPaymentListQuery,
  useAcceptRejectPaymentMutation,
} = mainApi;
